function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AppContext } from 'context';
import Account from 'modules/Account';
import ImplicitProfileSetup from './ImplicitProfileSetup';
import PatientSetup from './PatientSetup';
var _React_PureComponent;
class AccountSetup extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { activeProfileType, enrollCode, invitationCode } = this.props;
        if (activeProfileType === Account.constants.PROFILE_TYPES.HCP || activeProfileType === Account.constants.PROFILE_TYPES.CG) {
            return /*#__PURE__*/ _jsx(ImplicitProfileSetup, {
                activeProfileType: activeProfileType
            });
        }
        return /*#__PURE__*/ _jsx(PatientSetup, {
            enrollCode: enrollCode,
            invitationCode: invitationCode
        });
    }
}
_define_property(AccountSetup, "contextType", AppContext);
_define_property(AccountSetup, "propTypes", {
    // Explicit props
    enrollCode: PropTypes.string,
    invitationCode: PropTypes.string,
    // Implicit props
    activeProfileType: Account.shapes.profileType
});
const mapStateToProps = (state)=>({
        activeProfileType: Account.selectors.activeProfileType(state)
    });
const ConnectedAccountSetup = connect(mapStateToProps)(AccountSetup);
export default ConnectedAccountSetup;
